import React, { useEffect, useState } from "react";
import { FormattedMessage, } from "react-intl";
import { Row, Col, Skeleton, List, Card, Empty, } from 'antd';
import InvoiceGridView from "../../financial/invoice.gridview";
import { ListCustomerInvoices, SearchCustomerInvoice, } from '../../../services/invoices';

import EmptyImage from '../../../assets/images/empty.svg';

const ProfileFinancialView = ({
    history,
    customerID,
    ...props
}) => {

    const [loadingData, setLoadingData] = useState(true);
    const [invoiceList, setInvoiceList] = useState([]);
    const [searchInput, setSearchInput] = useState(undefined);
    const [filteredInfo, setFilteredInfo] = useState({});

    useEffect(() => {
        ListInvoices();
        // eslint-disable-next-line
    }, []);


    // Needed to have the search header bar working.
    useEffect(() => {
        const tmp_input = searchInput;

        if (tmp_input) {
            if (tmp_input.length > 2) {
                SearchCustomerInvoice({ search: tmp_input, cusotmer_id: customerID, invoice_type: 'all' }, history)
                    .then(response => {
                        setInvoiceList(response.data.invoice_list);
                        setLoadingData(false);
                        setSearchInput(tmp_input);
                    })
                    .catch(error => {
                        console.error('error: ', error);
                    });
            }
        }
        // eslint-disable-next-line
    }, [searchInput]);

    const ListInvoices = () => {
        ListCustomerInvoices(customerID, history)
            .then(response => {
                if (response.status) {
                    setInvoiceList(response.data.invoice_list);
                    setLoadingData(false);
                }
            })
            .catch(error => { });
    };

    return (
        <Row gutter={[32, 32]}>

            {invoiceList?.length > 0 || searchInput ? (
                <Col span={24} className="">
                    <Card
                        title={<h4 className="card-title"><FormattedMessage id="profile-invoice-header" /></h4>}
                        className="my-4"
                        styles={{ body: { paddingLeft: '0px', paddingRight: '0px' } }}
                        extra={[]}>
                        <InvoiceGridView
                            dataTable={invoiceList}
                            setDataLoading={setLoadingData}
                            dataLoading={loadingData}
                            history={history}
                            refreshData={ListInvoices}
                            searchInput={searchInput}
                            setSearchInput={setSearchInput}
                            filteredInfo={filteredInfo}
                            setFilteredInfo={setFilteredInfo}
                            {...props}
                        />
                    </Card>
                </Col>
            ) : (
                <Col span="24" className="">
                    {loadingData ? (
                        <Skeleton loading={loadingData} active className="bg-white p-3" style={{ backgroundColor: '#fff' }}>
                            <List.Item.Meta />
                        </Skeleton>
                    ) : (
                        <Empty
                            className="p-3 ant-empty-custom mt-4"
                            image={EmptyImage}
                            styles={{ image: { height: 60, } }}
                            description={<FormattedMessage id="financial-profile-empty" />}>
                        </Empty>
                    )}
                </Col>
            )}
        </Row>

    );
};

export default ProfileFinancialView;